import { recentListingStatus, marketReportStatus } from '../_config';
export default {
    // 调用 market report需要传递的参数
    marketReportParams(state, getters, rootState, rootGetters) {
        return {
            // ...rootGetters['search/searchParams'],
            ...state.searchParams,
            siteId: rootGetters.siteId
        };
    },
    // 调用获取listing 接口 需要传递的参数
    listingParams(state, getters, rootState, rootGetters) {
        return {
            // ...rootGetters['search/searchParams'],
            ...state.searchParams,
            siteId: rootGetters.siteId,
            listingStatus: state.currentListingStatus,
            page: state.pageNum,
            pageSize: state.pageSize
        };
    },
    // market snapshot相关状态展示
    showMarketReportData(state, getters) {
        return (
            (state.fetchMarketReportStatus === marketReportStatus.loading ||
                state.fetchMarketReportStatus === marketReportStatus.loaded) &&
            !getters.showMarketNoData
        );
    },
    showMarketReportLoading(state) {
        return state.fetchMarketReportStatus === marketReportStatus.loading;
    },
    showMarketNoLocation(state) {
        return state.fetchMarketReportStatus === marketReportStatus.noLocation;
    },
    showMarketComing(state) {
        return state.fetchMarketReportStatus === marketReportStatus.coming;
    },
    showMarketNoData(state) {
        const { count, avgSoldPrice, avgOnSaleDays } = state.marketReport;
        return (
            state.fetchMarketReportStatus !== marketReportStatus.coming &&
            state.fetchMarketReportStatus !== marketReportStatus.noLocation &&
            count === 0 &&
            avgSoldPrice === 0 &&
            avgOnSaleDays === 0
        );
    },
    // recent listing相关状态展示
    showRecentListingData(state, getters) {
        return (
            (state.fetchListingStatus === recentListingStatus.loading ||
                state.fetchListingStatus === recentListingStatus.loaded) &&
            !getters.showRecentListingNoData
        );
    },
    showRecentListingLoading(state) {
        return state.fetchListingStatus === recentListingStatus.loading;
    },
    showRecentListingNoLocation(state) {
        return state.fetchListingStatus === recentListingStatus.noLocation;
    },
    showRecentListingComing(state) {
        return state.fetchListingStatus === recentListingStatus.coming;
    },
    showRecentListingNoData(state) {
        return (
            state.fetchListingStatus !== recentListingStatus.coming &&
            state.fetchListingStatus !== recentListingStatus.noLocation &&
            state.listing.length === 0
        );
    },
    // 是否是sold listing
    isSoldListing(state) {
        return state.currentListingStatus.toLowerCase() === 'sold';
    }
};
